<template>
  <div class="grid grid-cols-5 gap-4">
    <div class="flex items-center col-span-2">
      <v-menu
        :disabled="isLoading"
        ref="menu"
        v-model="menuDateStart"
        :close-on-content-click="false"
        :return-value.sync="startDate"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :disabled="isLoading"
            :value="$helper.datelabel(startDate)"
            outlined
            dense
            hide-details
            readonly
            v-bind="attrs"
            :label="$t('from_date')"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          :disabled="isLoading"
          v-model="startDate"
          no-title
          scrollable
          locale="th"
          :header-date-format="$helper.headerDateFormat"
          :year-format="$helper.yearFormat"
          :weekday-format="$helper.formatWeekday"
          :month-format="$helper.formatMonth"
          @change="$refs.menu.save(startDate); menuDateStart = false"
        >
        </v-date-picker>
      </v-menu>
    </div>
    <div class="flex items-center col-span-2">
      <v-menu
        ref="menu1"
        :disabled="isLoading"
        v-model="menuDateEnd"
        :close-on-content-click="false"
        :return-value.sync="endDate"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :disabled="isLoading"
            :value="$helper.datelabel(endDate)"
            outlined
            dense
            hide-details
            readonly
            v-bind="attrs"
            :label="$t('to_date')"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          :disabled="isLoading"
          v-model="endDate"
          no-title
          scrollable
          locale="th"
          :header-date-format="$helper.headerDateFormat"
          :year-format="$helper.yearFormat"
          :weekday-format="$helper.formatWeekday"
          :month-format="$helper.formatMonth"
          @change="$refs.menu1.save(endDate); menuDateEnd = false"
        >
        </v-date-picker>
      </v-menu>
    </div>
    <div class="flex items-center">
      <v-btn
        v-if="!isDisabled"
        color="primary"
        @click="onClick"
        class="mx-2"
        block
        :loading="isLoading"
      >
        <v-icon left>mdi-magnify</v-icon>{{ $t('search') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "BetweenDate",
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menuDateStart: false,
      menuDateEnd: false,
      startDate: this.$moment()
        .startOf("month")
        .format("YYYY-MM-DD"),
      endDate: this.$moment()
        .endOf("month")
        .format("YYYY-MM-DD")
    };
  },
  methods: {
    onClick() {
      this.$emit("onClick", {
        startDate: this.$moment(this.startDate)
          .startOf("day")
          .toDate(),
        endDate: this.$moment(this.endDate)
          .endOf("day")
          .toDate()
      });
    }
  }
};
</script>

<style>
</style>